import React from 'react';
import {faPencil} from '@fortawesome/pro-solid-svg-icons';
import {
	type ExtendReactHookFormDialogProps,
	ReactHookFormDialog,
} from '@netx/core-components/FormDialog';
import {ScrollBorder} from '@netx/core-components/ScrollBorder';
import {styled} from '@netx/core-components/Theme';
import {
	AssetViewManagerActionLabel,
	AssetViewManagerTitle,
} from '../../locales';
import {AssetViewManager, type AssetViewManagerProps} from './AssetViewManager';

const AssetViewManagerDialogRoot = styled(ReactHookFormDialog)(
	({theme}) => ({}),
);

const AssetViewManagerStyled = styled(AssetViewManager)(({theme}) => ({
	padding: theme.spacing(1, 3),
}));

const AssetViewManagerDialogContent = styled(ScrollBorder)(({theme}) => ({}));

export interface AssetViewManagerDialogProps
	extends ExtendReactHookFormDialogProps,
		AssetViewManagerProps {}

export const AssetViewManagerDialogPrimative = ({
	assetView,
	form,
	open,
	FormProps,
	DialogProps,
	onClose,
	onSubmit,
	...props
}: AssetViewManagerDialogProps) => {
	return (
		<AssetViewManagerDialogRoot
			confirmLabel={AssetViewManagerActionLabel.SUBMIT}
			open={open}
			title={AssetViewManagerTitle.EDIT}
			{...FormProps}
			form={form}
			onClose={onClose}
			onSubmit={onSubmit}
			DialogProps={{
				disableContentPadding: true,
				icon: faPencil,
				fullScreenWhenMobile: true,
				fullWidth: true,
				maxWidth: 'xs',
				preventBackdropClose: true,
				secondaryTitle: assetView.name,
				...DialogProps,
			}}
		>
			<AssetViewManagerDialogContent>
				<AssetViewManagerStyled {...props} assetView={assetView} form={form} />
			</AssetViewManagerDialogContent>
		</AssetViewManagerDialogRoot>
	);
};

export const AssetViewManagerDialog = AssetViewManagerDialogPrimative;

export default AssetViewManagerDialog;
